// extracted by mini-css-extract-plugin
module.exports = {"root":"EventFilter__root___2rdZN","filter":"EventFilter__filter___3zeIy","label":"EventFilter__label___cG_zd"};